import { render, staticRenderFns } from "./NewRoomModal.vue?vue&type=template&id=6ea4541d&"
import script from "./NewRoomModal.vue?vue&type=script&lang=js&"
export * from "./NewRoomModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports